/**
 * Transforme la réponse de GET /hr/pilotage/retention en modèle
 * consommé par RetentionSection. Les valeurs `null` de l'API sont
 * conservées (affichées "—").
 */
export const mapRetention = (api) => ({
    tauxRetention: api.retention_rate ?? null,
    tauxRetentionPrevious: api.retention_rate_previous ?? null,
    confirmationEssai: api.probation_confirmation_rate ?? null,
    confirmationEssaiPrevious:
        api.probation_confirmation_rate_previous ?? null,
    recrutementReussi: api.successful_recruitment_12m ?? null,
    recrutementReussiPrevious: api.successful_recruitment_12m_previous ?? null,
    anciennete: api.average_tenure ?? null,
    anciennetePrevious: api.average_tenure_previous ?? null,
    mobilite: api.internal_mobility_rate ?? null,
    mobilitePrevious: api.internal_mobility_rate_previous ?? null,
});
